<template>
<div>
    <b-modal ref="modal" title="Deseja excluir o certificado?" header-class="border-bottom-0" size="lg">
        <div class="container-fluid">
            <div>
                Atenção! Após a exclusão o arquivo será removido
                e não será possivel a recupera-lo em nossa base de dados.
            </div>
        </div>
        <div slot="modal-footer">
            <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
                <i class="fas fa-times"></i> Cancelar
            </button>
            <button role="button" class="btn btn-danger" style="margin-left:5px" @click="deleteCertificate()">
                <i class="fas fa-check"></i> Excluir
            </button>
        </div>
    </b-modal>
</div>
</template>

<script>
export default {

    data: function () {
        return {
            row: {},
        };
    },

    methods: {
        open(row) {

            this.row = row;
            this.$refs.modal.show();
        },

        deleteCertificate() {

            this.$store.commit("showLoading");

            let form = new FormData();

            form.append("id", this.row.id);
            form.append("path", this.row.path);

            axios
                .post("api/certificate/delete", form)
                .then(response => {

                    this.$store.commit("hideLoading");
                    this.$refs.modal.hide();
                    this.$emit("stored");

                    this.$store.commit("showAlert", {
                        message: "Certificado Excluido com sucesso!",
                        type: "Success"
                    });
                })
                .catch(error => {
                    console.log(error)
                    this.error = error;
                    this.$store.commit("hideLoading");
                });
        }
    }
}
</script>

<style>

</style>
